__turbopack_context__.v({
  "error": "UeKf5q_error",
  "productList": "UeKf5q_productList",
});
